module.exports = __webpack_public_path__ + "img/goods-receipt-documents.c160efa0.svg";